import type { HttpClient } from './http';
import { authEndpoints, type AuthEndpoints } from './endpoints/auth';
import { inviteEndpoints, type InviteEndpoints } from './endpoints/invites';
import { notificationEndpoints, type NotificationEndpoints } from './endpoints/notifications';
import { dashboardEndpoints, type DashboardEndpoints } from './endpoints/dashboard';
import { clientEndpoints, type ClientEndpoints } from './endpoints/clients';
import { planEndpoints, type PlanEndpoints } from './endpoints/plans';
import { clientPlanEndpoints, type ClientPlanEndpoints } from './endpoints/clientPlans';
import { invoiceEndpoints, type InvoiceEndpoints } from './endpoints/invoices';
import { paymentEndpoints, type PaymentEndpoints } from './endpoints/payments';
import { proofEndpoints, type ProofEndpoints, type ProofImageFetcher } from './endpoints/proofs';
import { membershipEndpoints, type MembershipEndpoints } from './endpoints/membership';
import { mePlanEndpoints, type MePlanEndpoints } from './endpoints/mePlan';
import { reportEndpoints, type ReportEndpoints } from './endpoints/reports';
import { referralEndpoints, type ReferralEndpoints } from './endpoints/referrals';
import { settingsEndpoints, type SettingsEndpoints } from './endpoints/settings';
import { orgEndpoints, type OrgEndpoints } from './endpoints/org';
import { providerEndpoints, type ProviderEndpoints } from './endpoints/providers';
import { clientViewEndpoints, type ClientViewEndpoints } from './endpoints/clientView';
import { platformEndpoints, type PlatformEndpoints } from './endpoints/platform';
import { platformBillingEndpoints, type PlatformBillingEndpoints } from './endpoints/platformBilling';
import { platformTeamEndpoints, type PlatformTeamEndpoints } from './endpoints/platformTeam';
import { platformSettingsEndpoints, type PlatformSettingsEndpoints } from './endpoints/platformSettings';
import { platformReferralsEndpoints, type PlatformReferralsEndpoints } from './endpoints/platformReferrals';

export interface ApiClient {
  http: HttpClient;
  auth: AuthEndpoints;
  invites: InviteEndpoints;
  notifications: NotificationEndpoints;
  dashboard: DashboardEndpoints;
  clients: ClientEndpoints;
  plans: PlanEndpoints;
  clientPlans: ClientPlanEndpoints;
  invoices: InvoiceEndpoints;
  payments: PaymentEndpoints;
  proofs: ProofEndpoints;
  membership: MembershipEndpoints;
  mePlan: MePlanEndpoints;
  reports: ReportEndpoints;
  referrals: ReferralEndpoints;
  settings: SettingsEndpoints;
  org: OrgEndpoints;
  providers: ProviderEndpoints;
  clientView: ClientViewEndpoints;
  platform: PlatformEndpoints;
  platformBilling: PlatformBillingEndpoints;
  platformTeam: PlatformTeamEndpoints;
  platformSettings: PlatformSettingsEndpoints;
  platformReferrals: PlatformReferralsEndpoints;
}

export function createApiClient(http: HttpClient, imgFetcher?: ProofImageFetcher): ApiClient {
  return {
    http,
    auth: authEndpoints(http),
    invites: inviteEndpoints(http),
    notifications: notificationEndpoints(http),
    dashboard: dashboardEndpoints(http),
    clients: clientEndpoints(http),
    plans: planEndpoints(http),
    clientPlans: clientPlanEndpoints(http),
    invoices: invoiceEndpoints(http),
    payments: paymentEndpoints(http),
    proofs: proofEndpoints(http, imgFetcher),
    membership: membershipEndpoints(http),
    mePlan: mePlanEndpoints(http),
    reports: reportEndpoints(http),
    referrals: referralEndpoints(http),
    settings: settingsEndpoints(http),
    org: orgEndpoints(http),
    providers: providerEndpoints(http),
    clientView: clientViewEndpoints(http),
    platform: platformEndpoints(http),
    platformBilling: platformBillingEndpoints(http),
    platformTeam: platformTeamEndpoints(http),
    platformSettings: platformSettingsEndpoints(http),
    platformReferrals: platformReferralsEndpoints(http),
  };
}
